var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-kyb",on:{"click":_vm._down}},[_c('div',{staticClass:"icon-name"},[_c('img',{attrs:{"src":_vm.iconObj.icon,"alt":""}}),_vm._v(" "+_vm._s(_vm.iconObj.title)+" ")]),_c('span',[_vm._v(_vm._s(_vm.iconObj.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }